module.exports = __webpack_public_path__ + "static/media/mountain_bike.8ae5ef2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Explore/images/mountain_bike.jpg
// module id = 1599
// module chunks = 0